var ToggleClass = function () {

    function init () {
        $('body').on('click', '[data-toggle-el]', function (event) {
            event.preventDefault();
            var toggleClass = $(this).data('toggle-class') || 'show';
            $($(this).data('toggle-el')).toggleClass(toggleClass);
            $(this).toggleClass('toggled');
        });
    }

    return {
        init: init
    }

}();
